import React from 'react';
import PropTypes from 'prop-types';
import { Form, Typography, Flex } from 'antd';
import { ReactComponent as LeftBackSvg } from '../../assets/icons/back-left.svg';
import Icon from '@ant-design/icons';

const { Title, Text } = Typography;

const LoginFormLayout = ({
  children,
  onFinish,
  title,
  form,
  showBackButton = true,
  onBack = () => {},
  isMobileLogin = false,
}) => {
  // If form not passed as prop, create a new one
  const [internalForm] = Form.useForm();
  const currentForm = form || internalForm;
  const handleBack = () => {
    currentForm?.resetFields?.();
    onBack();
  };

  return (
    <Flex
      className="auth-box"
      vertical
      justify="center"
      align="center"
      style={{ width: isMobileLogin ? '90%' : '35%' }}
    >
      {showBackButton && (
        <Flex className="full-width" align="start">
          <Flex onClick={handleBack} gap={8} align="center">
            <Icon component={LeftBackSvg} style={{ fontSize: '24px' }} />
            <Text>Back</Text>
          </Flex>
        </Flex>
      )}
      <Title level={3} style={{ margin: '32px 0 16px' }}>
        {title}
      </Title>
      <Form
        layout="vertical"
        form={currentForm}
        onFinish={onFinish}
        scrollToFirstError
        requiredMark={false}
        style={{ width: '90%' }}
      >
        {children}
      </Form>
    </Flex>
  );
};

LoginFormLayout.propTypes = {
  children: PropTypes.node,
  onFinish: PropTypes.func,
  title: PropTypes.string,
  form: PropTypes.object,
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
  isMobileLogin: PropTypes.bool,
};

export default LoginFormLayout;
